import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A loading block: skeleton lines in the shape of its content, no page spinner (design b3). */
const HomeBlockSkeletonComponent: React.FC = () => (
  <div className="d-flex flex-column gap-3" aria-hidden>
    <div className={clsx(styles.skLine, 'w-25')} />
    <div className="d-flex flex-column gap-2">
      <div className={clsx(styles.skLine, 'w-75')} />
      <div className={clsx(styles.skLine, 'w-50')} />
    </div>
    <div className={styles.trio}>
      <div className={styles.skBox} />
      <div className={styles.skBox} />
      <div className={styles.skBox} />
    </div>
  </div>
);

export const HomeBlockSkeleton = TypedMemo(HomeBlockSkeletonComponent);
